export const pushPageSensitivity = (pageIsSensitive: boolean): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ page_is_sensitive: pageIsSensitive });
};
